module.exports = __webpack_public_path__ + "static/esq-cc462e584093606ed3ea6281b5141a26.png";